// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import riskProjectEntity from './entities/risk-project.json';
import riskProjectMenu from '../pages/risk-project/menu.json';
import riskProjectFullForm from '../pages/risk-project/forms/full.json';
import riskProjectContextForm from '../pages/risk-project/forms/context.json';
import riskProjectMiniForm from '../pages/risk-project/forms/mini.json';
import riskProjectLookupForm from '../pages/risk-project/forms/lookup.json';
import riskProjectTableView from '../pages/risk-project/views/table.json';
import riskProjectCardsView from '../pages/risk-project/views/cards.json';
import riskProjectDashboardView from '../pages/risk-project/views/dashboard.json';

/** Тип запису «Проєкт під ризиком» зі сторінками пакета: меню, форми та подання з pages/risk-project/. */
export const riskProjectDefinition: IRecordTypeDefinition = {
  ...riskProjectEntity,
  views: assembleViewSet({
      table: riskProjectTableView,
      cards: riskProjectCardsView,
      dashboard: riskProjectDashboardView,
  }),
  form: riskProjectFullForm,
  forms: { full: riskProjectFullForm, context: riskProjectContextForm, mini: riskProjectMiniForm, lookup: riskProjectLookupForm },
  menu: riskProjectMenu,
} as IRecordTypeDefinition;
